module.exports = {
    'demoModule.title': 'gMap module title',
    'gMapModule.mapDeleteShapeButton': 'Delete Selected Shape',
    'gMapModule.mapDirectionPathLenght': 'Directions path length:',
    'gMapModule.mapCreateRoute': 'Create route',
    'gMapModule.mapDeleteDirection': 'Delete route',
    'gMapModule.mapShowTrafficLayer': 'Show traffic',
    'gMapModule.mapShowTransitLayer': 'Show transit',
    'gMapModule.mapEnterAddress': 'Enter address',
    'gMapModule.doubleClickToOpenEvent': 'Double click show event',
    'gMapModule.dblClick4Details': 'Double click for details',
    'gMapModule.directionOrigin': 'Enter an origin location',
    'gMapModule.directionDestination': 'Enter a destination location',
    'gMapModule.directionByDriving': 'Car',
    'gMapModule.directionByTransit': 'Public transport',
    'gMapModule.directionByWalking': 'On foot',
    'gMapModule.directionByBycicling': 'Bike',
    'gMapModule.routeSelectOption': 'Please select an option from the dropdown list',
    'gMapModule.routeError': 'An error has occurred. Please try again',
    'gMapModule.routeNoResult': 'No result found',
    'gMapModule.routeSearchOnMap': 'Search on the map'
};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-gMapModule/languages/en.js
// module id = 334
// module chunks = 0